/* Builder A · WF-06 shared bits. No new CSS — « verrouillé » uses the
   existing .pill .pill-done classes with no glyph, as the frame draws an ink
   chip carrying the bare word. */
import { Link } from 'react-router-dom'
import { Skeleton } from '@/ui'
import type { DemandeKind } from './api'

export const Retour = () => (
  <p className="f-help" style={{ margin: 0 }}><Link to="/campagnes/parcours">‹ Parcours fidélité</Link></p>
)

export const Verrouille = () => <span className="pill pill-done">verrouillé</span>

/** What a step asks, at a glance. Glyphs only — the word always travels beside
 *  them (F-12), so nothing here carries meaning on its own. */
export const MARQUE: Record<DemandeKind, string> = {
  avis: '★', quiz: '❓', question: '💬', retour: '🔒', cadeau: '🎁',
}
export const DEMANDE_MOT: Record<DemandeKind, string> = {
  avis: 'Avis', quiz: 'Quiz', question: 'Question', retour: 'Retour privé', cadeau: 'Cadeau seul',
}

/* Batch 12: `REGLES_PARCOURS` and `RIEN_NE_CONDITIONNE` moved to `@/lib/vocab`.
   The campaign stepper's step 3 prints the same list, so one copy is the point —
   import them from there, not from here. */

export const Chargement = () => (
  <div style={{ display: 'grid', gap: 10, maxWidth: 720 }}>
    <Skeleton width="42%" /><Skeleton /><Skeleton width="65%" />
  </div>
)
